import React from "react";
import { Box, Typography } from "@mui/material";
import { formatNumber } from "@/utils/numberUtils";
import { EstimateCreditsDetailResponse } from "@/apis/exportTrackingApi";
import { CreditsBreakdownTable } from "@/components/Export/CreditsBreakdownTable";

interface CreditsEstimateDetailsProps {
  data: EstimateCreditsDetailResponse;
}

export const CreditsEstimateDetails: React.FC<CreditsEstimateDetailsProps> = ({
  data,
}) => {
  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          mb: 2,
          p: 2,
          bgcolor: "grey.50",
          borderRadius: 1,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" color="primary">
          Total Credits Estimate
        </Typography>
        <Typography variant="h4" color="primary">
          {formatNumber(data.credits_estimate)}
        </Typography>
      </Box>

      <CreditsBreakdownTable details={data.details} />
    </Box>
  );
};
